import { PTO_URL } from '@/api/pto/const'
import { createBaseResponseErrors, createUniqueError } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi, createCreateUniqueApi } from '@/api/base'

export const PTO_HANDBOOK_NOMENCLATURE_STANDARD_URL = `${PTO_URL}/nomenclature-standard`

const errors = {
  ...createBaseResponseErrors('стандарт', 'стандартов'),
  ...createUniqueError('Стандарт')
}

export const PTOHandbookNomenclatureStandardApi = {
  ...createBaseCRUDApi(PTO_HANDBOOK_NOMENCLATURE_STANDARD_URL, errors),
  ...createCreateUniqueApi(PTO_HANDBOOK_NOMENCLATURE_STANDARD_URL, errors)
}
